import '../assets/css/Home.css'
import milles_logo from '../assets/img/milles_logo.svg';
import pil from '../assets/img/pil.svg';

export const Home = () => {
    return (
        <main className="home__wrapper">
            <section className="container">
                <div className="home__content">
                    <img src={milles_logo} alt="Milles logo" className="milles__logo"/>
                    <div className="open__hours__wrapper">
                        <h2>Öppettider</h2>
                        <div className="open__hours">
                            <div>
                                <p>Tis - Tor</p>
                                <p>11:30 - 23:00</p>
                            </div>
                            <div>
                                <p>Fre - Lör</p>
                                <p>11:30 - 00:00</p>
                            </div>
                            {/* <div>
                                <p>Sön & Mån</p>
                                <p>Stängt</p>
                            </div> */}
                        </div>
                    </div>
                    <div className="menu">
                        <a href="/meny.pdf" target="_blank" rel="noopener noreferrer">
                            Meny
                        </a>
                    </div>
                    <div className="book__table">
                        <a href="https://app.waiteraid.com/reservation/?hash=0d382f6f35b0bfa69542d81a04a50e24" target="_BLANK" rel="noreferrer" className="book__link">
                            Boka bord
                            <img src={pil} alt="Pil" className="pil" height="20"/>
                        </a>
                    </div>
                    <div className="contact__info">
                        <div>
                            <a href="https://maps.google.com" target="_BLANK" rel="noreferrer">
                                Strandvägen 1
                            </a>
                            <a href="https://maps.google.com" target="_BLANK" rel="noreferrer">
                                114 51 Stockholm
                            </a>
                        </div>
                        <div>
                            <a href="tel:+4686638002">
                                +46 8 663 80 02
                            </a>
                            <a href="mailto:info@mmilles.se" className="email">
                                info@mmilles.se
                            </a>
                        </div>
                        <div>                
                            <span>
                                &nbsp;
                            </span>
                            <a href="https://www.instagram.com/michellevandermilles/" target="_BLANK" rel="noreferrer">
                                instagram
                            </a>
                        </div>
                    </div>
                </div>
            </section>
        </main>
    )
}